// extracted by mini-css-extract-plugin
export default {"box":"label_box__VIoHW"};